<template>
  <div class="product-card" @click="handleClick">
    <div class="product-card-content">
      <img :src="product.homeImg" :alt="product.name" />
      <div class="product-info">
        <h4>{{ product.name }}</h4>
        <div class="product-price-sales">
          <div class="product-price">¥{{ product.retailPrice }}</div>
          <div class="product-sales">{{ product.stockNum }}人评价</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({
        homeImg: '',
        name: '',
        retailPrice: '0.00',
        stockNum: 0
      })
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.product)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-card {
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 2px;
  overflow: hidden;
  background: #fff;
  height: 250px;
  border: 1px solid #eee;
  padding: 5px;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .product-card-content {
    height: 100%;
    img {
      width: 96%;
      height: 176px;
      object-fit: cover;
      display: block;
    }

    .product-info {
      padding: 0 10px;
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: calc(100% - 176px);

      h4 {
        margin: 8px 0;
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        min-height: 36px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .product-price-sales {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .product-price {
        color: #ff6b6b;
        font-size: 16px;
        font-weight: bold;
      }

      .product-sales {
        color: #999;
        font-size: 12px;
      }
    }
  }
}
</style>
